import Axios from 'axios'

// let axios = Axios.create({
// 	baseURL: 'http://localhost:8081/api',
// });

// axios.interceptors.request.use(config=>{
// 	// config.headers.aa = 111;
// 	return config;
// });

// export default axios;

export default Axios.create({
	// baseURL: 'http://localhost:8081/api',
	baseURL: 'http://szliang.cn/api',
	headers:{'S-Mode': '__a_j'}
})